
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Gallery, { ResourceMeta } from "@/components/Gallery.vue";
import "@/helpers/filters";
import PrintButton from "@/components/PrintButton.vue";

import { seenatlasService } from "../service";
import {
  SAStammdatenBase,
  SAStammdatenVerwaltungseinheiten,
  SAFreizeitnutzungsTyp,
  SAFreizeitnutzungen,
  SASKommerziellerNutzungsTyp,
  SAKommerzielleNutzung,
  SASeeMischungVerhaeltnis,
  SASee,
  SAFachinformation,
  SAFachinformationMessstelle
} from "../interfaces";

@Component({ components: { Gallery, PrintButton } })
export default class Stammdaten extends Vue {
  seeId = 0; // See_id Ist unterschiedlich zur Seenr
  length = 0; // length

  @Prop()
  id!: string; // Ist die See_Nr, aber Router übergibt id!

  stammdaten: SAStammdatenBase | null = null;
  stammdatenVerwaltungseinheiten: Array<
    SAStammdatenVerwaltungseinheiten
  > | null = null;

  // Kann weg?
  freizeitNutzungTypes: Array<SAFreizeitnutzungsTyp> | null = null;
  // Kann weg?
  kommerzielleNutzungTypes: Array<SASKommerziellerNutzungsTyp> | null = null;

  stammdatenFreizeitnutzungen: Array<SAFreizeitnutzungen> | null = null;

  stammdatenKommerziellnutzung: Array<SAKommerzielleNutzung> | null = null;

  seeMischungVerhaeltnis: Array<SASeeMischungVerhaeltnis> | null = null;

  seenListe: Array<SASee> | null = null;

  stammdatenFachinformation: SAFachinformation | null = null;

  stammdatenFachinformationMessstellen: Array<
    SAFachinformationMessstelle
  > | null = null;

  imageResourceMeta: ResourceMeta = {
    application: "seenatlas",
    resource: "foto",
    id: this.id
  };

  dataLength(array) {
    this.length = array.length;
  }

  setCommaVerwaltungsEinheiten() {
    let result = "";
    if (this.stammdatenVerwaltungseinheiten) {
      this.stammdatenVerwaltungseinheiten.forEach(fe => {
        result += fe.lk_bez + " / " + fe.og_bez + ", ";
      });
    }
    return result.slice(0, -2);
  }

  setCommaMesstellen() {
    let result = "";
    if (this.stammdatenFachinformationMessstellen) {
      this.stammdatenFachinformationMessstellen.forEach(fe => {
        result += fe.messst_nr + ", ";
      });
    }
    return result.slice(0, -2);
  }

  setCommaFreizeitnutzungen() {
    let result = "";
    if (this.stammdatenFreizeitnutzungen) {
      this.stammdatenFreizeitnutzungen.forEach(fe => {
        result += fe.nutzung_bez + ", ";
      });
    }
    return result.slice(0, -2);
  }

  beforeMount() {
    this.getStammdaten(this.id);
    this.getSAFachinformationMessstellen(this.id);
    this.getSAFachinformationen(this.id);
  }

  @Watch("seeId")
  dependencyWatch(): any | null {
    this.getSAVerwaltungseinheiten(this.seeId);
    this.getSAFreizeitnutzungen(this.seeId);
    this.getSAKommerzielleNutzungen(this.seeId);
  }

  getStammdaten(id: string) {
    seenatlasService
      .getSAStammdatenBase(id)
      .then(response => {
        this.stammdaten = response.data[0];
        if (this.stammdaten) {
          this.seeId = this.stammdaten.id;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSAVerwaltungseinheiten(seeId: number) {
    seenatlasService
      .getSAVerwaltungseinheiten(seeId)
      .then(response => {
        this.stammdatenVerwaltungseinheiten = response.data;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSAFreizeitnutzungen(seeId: number) {
    seenatlasService
      .getSAFreizeitnutzungen(seeId)
      .then(response => {
        this.stammdatenFreizeitnutzungen = response.data.filter(
          // nutzung_jn == 1 heißt es wird benutzt. 0 heißt nicht benutzt.
          freizeitnutzung => freizeitnutzung.nutzung_jn == 1
        );
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSAKommerzielleNutzungen(seeId: number) {
    seenatlasService
      .getSAKommerzielleNutzungen(seeId)
      .then(response => {
        this.stammdatenKommerziellnutzung = response.data.filter(
          kommerzNutzung => kommerzNutzung.nutzung_jn == 1
        );
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSAFachinformationen(see_nr: string) {
    seenatlasService
      .getSAFachinformationen(see_nr)
      .then(response => {
        this.stammdatenFachinformation = response.data[0];
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSAFachinformationMessstellen(see_nr: string) {
    seenatlasService
      .getSAFachinformationMessstellen(see_nr)
      .then(response => {
        this.stammdatenFachinformationMessstellen = response.data;
      })
      .catch(e => {
        console.error(e);
      });
  }
}
